<template>
  <div>
    <img src="@/assets/images/zwsj.png"/>
  </div>
</template>
<script>
  export default {
    name: 'DataEmpty',
  }
</script>
<style scoped>
div{
  width: 100%;
  margin: 20px auto;
  text-align: center;
}
div img{
  width: 30%;
}

</style>


// WEBPACK FOOTER //
// src/components/Data.vue